<template>
  <v-container grid-list-sm text-xs-left>
    <v-form ref="form">
      <v-text-field
          v-model="synonym.basic_word"
          label="Basic Word"
          :rules="[rules.required, rules.max, rules.min3]"
          :counter="32"
          required
          @input="$v.basic_word.$touch()"
          @blur="$v.basic_word.$touch()"
      />
      <v-text-field
          v-model="synonym.synonyms"
          label="Synonyms (please separate synonyms by comma)"
          required
          :rules="[rules.required]"
          @input="$v.synonyms.$touch()"
          @blur="$v.synonyms.$touch()"
      />

      <v-flex class="mt-3">
        <v-btn round dark color="green" @click="submit">
          Submit
        </v-btn>
        <v-btn round dark color="red" @click="clear">
          Clear
        </v-btn>
      </v-flex>
    </v-form>

    <v-dialog v-model="registrationStatus" max-width="450">
      <v-card v-if="registrationError===409">
        <v-card-title class="headline error white--text">Creation failed</v-card-title>
        <v-card-text>User with this username already exists!</v-card-text>
      </v-card>
      <v-card v-else-if="registrationError===200">
        <v-card-title class="headline success white--text">Synonym successfully updated</v-card-title>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline error white--text">Creation failed</v-card-title>
        <v-card-text>Something went wrong... Retry!</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {validationMixin,} from "vuelidate";
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import UrlsService from "@/helpers/UrlsService";
import TimeService from "@/helpers/TimeService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

export default {
  name: "NewSynonym",
  components: {},
  mixins: [validationMixin,],
  validations: {
    basic_word: {required, minLength: minLength(3), maxLength: maxLength(32)},
  },

  data: () => ({
    rules: {
      required: value => !!value || 'Required',
      min3: v => v.length >= 3 || 'Basic Word must be at least 3 characters long',
      max: v => v.length <= 32 || 'Basic Word must be at most 32 characters long',
      /*synonyms: value => {
          const pattern = /^(?!,)^[a-zA-Z0-9,\s]*(?<![,\s])$/
          return value === '' || pattern.test(value) || 'Invalid synonyms'
      }*/
    },
    synonym: {
      basic_word: "",
      synonyms:"",
      firstName: "",
    },
    newSynonym: false,
    registrationStatus: false,
    registrationError: 200,
  }),

  computed: {
    passwordConfirmationRule() {
      return () => (this.password === this.confirmPassword) || 'Password must match'
    },
  },
  methods: {
    fillFields(item){
      this.synonym = item;
    },
    setSynonym(value){
      this.newSynonym = value;
    },
    submit() {
      this.$v.$touch();
      if(this.$refs.form.validate()) {
        if(this.newSynonym){
          this.createNewSynonym();
        }
        else {
          this.updateSynonym();
        }
      }
    },
    updateSynonym(){
      console.log("Modifico il Sinonimo")
      let requestUrl = {
        url: UrlsService.synonymsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          synonymRequest: {
            synonym: {
              _id: this.synonym.id,
              basic_word: this.synonym.basic_word,
              synonyms: this.synonym.synonyms
            },
            operation: "update"
          }
        }
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData
        },
      };
      let messages = {
        title: "Create new synonym",
        loading: "Creating",
        error: "Server Error",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let response = responseSuccess;
            this.registrationStatus = true;
            if(response.response !== undefined) {
              this.registrationError = response.response.status;
            } else{
              this.registrationError = 200;
              this.$emit("submit")
              this.clear();
            }

          });

      this.clear();


    },
    createNewSynonym(){
      console.log("Creo nuovo sinonimo");
      let requestUrl = {
        url: UrlsService.synonymsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          synonymRequest: {
            synonym: {
              basic_word: this.synonym.basic_word,
              synonyms: this.synonym.synonyms
            },
            operation: "create"
          }
        }
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData
        },
      };
      let messages = {
        title: "Create new synonym",
        loading: "Creating",
        error: "Server Error",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };

      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let response = responseSuccess;
            this.registrationStatus = true;
            if(response.response !== undefined) {
              this.registrationError = response.response.status;
            } else{
              this.registrationError = 200;
              this.$emit("submit")
              this.clear();
            }

          });

    },
    clear() {
      this.synonym.basic_word = "";
      this.synonym.synonyms = "";
    },
  },
};
</script>

<style lang="scss">
</style>
